<div *ngIf="IsNeedNewLine" class="en" style="height:20px;">
  &nbsp;
</div>
<span *ngIf="Text && Text != ''" class="content_header {{localService.selectedLanguageCode}}"
  [ngClass]="isWrap ? 'span_wrap '+LanguageCode : LanguageCode"
  [ngStyle]="{'font-weight' : IsBold ? 'bold' : 'normal', 'color' : color}">{{Text}}&nbsp;</span>
<span *ngIf="IsAllMandatory || IsMandatory" style="color:red;"
  title="{{IsAllMandatory ? localService.languageContent.common.mandatory_all : localService.languageContent.common.mandatory}}">*&nbsp;</span>
<span *ngIf="IsPartiallyMandatory" style="color:darkorange;"
  title="{{localService.languageContent.common.mandatory_partial}}">*&nbsp;</span>
<span class="en" *ngIf="IsColonRequired" [ngStyle]="{'float' : IsColonRight ? 'right' : 'none'}">:&nbsp;</span>
<i class="material-icons" *ngIf="HelpKey" (click)="localService.showSummary(HelpKey, 6)">help_outline</i>